import { FileUploadProgressDTO } from "@js/DTO/FileUploadProgressDTO.cs.d";
import { OrganisationService } from "@js/services/OrganisationService";
import { RoleService } from "@js/services/RoleService";
import { SelectListService } from "@js/services/SelectListService";
import {
  ApplicationUser,
  ApplicationUserClient,
  ApplicationUserCrudClient,
  ApplicationUserInsert,
  AppPackagePricing,
  ClaimClient,
  ClaimGroup,
  ClaimGroupsInApplicationUser,
  Lender,
  LenderClient,
  LenderProductTypeEnum,
  LocationEnum,
  Organisation,
  OrganisationClient,
  PaymentClient,
  UserClient,
} from "@src/apis/ModularClient";
import { Expand } from "@ccq/ts-lib";
import { UserService } from "@js/services/UserService";
import { ODataHelper } from "@js/helpers/ODataHelper";

export class UserController {
  users: Expand<ApplicationUser, { claimGroupsInApplicationUsers: { claimGroup: true } }>[];
  claimGroups: ClaimGroup[];
  uIRoles: ClaimGroup[];
  selectedUser: Expand<ApplicationUser, { claimGroupsInApplicationUsers: { claimGroup: true } }>;
  selectedRole: string;
  uploadingFiles: FileUploadProgressDTO[];
  imagePath: string[];
  organisations: Organisation[];
  organisationName: string;

  userForm: ng.IFormController;
  page: number = 1;
  pageid: any;
  userFilter: string = "";
  countperpage: number = 10;
  countTotal: number = 0;
  introduceClientModal: number = null;
  unique: string;
  isBroker: boolean = false;
  isLender: boolean = false;
  isSelectedUserAdmin: boolean = false;
  isOrgAdmin: boolean = false;

  currentItemRoleSet: ClaimGroup[];

  loadingRoles: boolean;
  loadingUsers: boolean;
  error: boolean;
  errorMessage: { user: ApplicationUser; deleteAllWarning: boolean } = {} as {
    user: ApplicationUser;
    deleteAllWarning: boolean;
  };
  allActiveAppPackagePrices: AppPackagePricing[];
  assignLicense: boolean = true;
  selectedProductList: AppPackagePricing[] = [];
  licenseEndDate: string;
  message: string;
  licenseStatusText: string;
  testEmailBody: string = "This is a test email.";
  testEmailSub: string = "Test email";
  testEmails: string;
  showTestEmailModal: boolean = false;
  onSendTestEmailClick: boolean = false;

  referrerOptions = [];
  locationOptions = [];

  hasLenderrole: boolean = false;
  lenderUserProductType: {}[] = [];
  lenders: Lender[];
  assignedLenderUsers: ApplicationUser[];
  singleLenderAdminError: string = "";

  noLicenseToAssignForAdminMessage: string;
  dataLoading: boolean;
  isTestSite: boolean = false;
  static $inject = [
    "$q",
    "ApplicationUserClient",
    "UserClient",
    "$scope",
    "$rootScope",
    "$cookies",
    "$location",
    "$http",
    "RoleService",
    "OrganisationService",
    "SelectListService",
    "LenderClient",
    "ApplicationUserCrudClient",
    "OrganisationClient",
    "PaymentClient",
    "ClaimClient",
    "UserService",
    "ODataHelper",
  ];

  constructor(
    private $q: ng.IQService,
    private applicationUserClient: ApplicationUserClient,
    private userClient: UserClient,
    private $scope: ng.IScope,
    private $rootScope: ng.IRootScopeService,
    private $cookies: ng.cookies.ICookiesService,
    private $location: ng.ILocationService,
    private $http: ng.IHttpService,
    private $roleClient: RoleService,
    private organisationService: OrganisationService,
    private selectListService: SelectListService,
    private lenderClient: LenderClient,
    private applicationUserCrudClient: ApplicationUserCrudClient,
    private OrganisationClient: OrganisationClient,
    private $paymentClient: PaymentClient,
    private claimClient: ClaimClient,
    private userService: UserService,
    private odataHelper: ODataHelper,
  ) {
    this.loadRoles();
    this.currentItemRoleSet = [];
    this.setPage(1);
    this.imagePath = [];
    userService.fileSelected = "img/BrickFlow_Logo_RGB_Blue.svg";

    //bring all organisations
    this.OrganisationClient.list().then((response) => {
      this.organisations = response;
    });

    this.referrerOptions = this.selectListService.GetReferrerOptions();
    this.locationOptions = this.selectListService.GetLocations();
  }

  userOpportunityById(userId: number) {
    this.organisationService.fetchAll().then((response) => {
      const found = response.find((organisation) => organisation.id === userId);
      if (found) {
        return (this.organisationName = found.name);
      } else {
        return (this.organisationName = "None");
      }
    });
  }

  formChanged(): void {
    (this.$rootScope as any).formSaved = false;
  }

  loadRoles(): void {
    this.claimClient
      .claimGroupsList(false, false, false, true)
      .then((response) => {
        this.claimGroups = response.filter((role) => role.name !== "None");

        this.claimGroups.forEach((role) => {
          (role as any).isHidden = role.name === "OrganisationAdmin";
        });

        this.uIRoles = this.claimGroups.filter((role) => role.name !== "OrganisationAdmin");

        this.loadingRoles = false;
      })
      .catch((response) => {
        this.error = true;
        this.loadingRoles = false;
      });
  }
  getgroups(): void {
    this.currentItemRoleSet = [];
    this.claimGroups.forEach((item: ClaimGroup) => {
      (item as any).ticked = false;

      this.selectedUser.claimGroupsInApplicationUsers.forEach((role: ClaimGroupsInApplicationUser) => {
        if (role.claimGroup.name == item.name) {
          if (item.name == "Introducer") {
            (item as any).thisItemIsDisabled = true;
          }
          this.currentItemRoleSet.push(item);
          (item as any).ticked = true;
        }
      });
    });
  }

  showManageLicenseButton() {
    // Check if the selected user exists and has necessary properties
    const userIsValid = this.selectedUser && this.selectedUser.id && this.selectedUser.userName && this.isOrgAdmin;

    // Return true if user is valid and has "Broker" role, otherwise false
    if (userIsValid) {
      return this.currentItemRoleSet.some((claim) => claim.name === "Broker");
    }

    return false;
  }

  isUserBroker() {
    this.isBroker =
      this.selectedUser.claimGroupsInApplicationUsers.find((role) => role.claimGroup.name === "Broker") !== undefined;
  }

  isUserAdmin() {
    this.isSelectedUserAdmin =
      this.selectedUser.claimGroupsInApplicationUsers.find((role) => role.claimGroup.name === "Admin") !== undefined;
  }

  isUserLender() {
    this.isLender =
      this.selectedUser.claimGroupsInApplicationUsers.find((role) => role.claimGroup.name === "Lender") !== undefined;
  }

  isUserOrgAdmin() {
    this.isOrgAdmin =
      this.selectedUser.claimGroupsInApplicationUsers.find((role) => role.claimGroup.name === "OrganisationAdmin") !==
      undefined;
  }

  getFilterLogic() {
    const userFilter = this.userFilter?.trim();
    const words = userFilter ? userFilter.split(/\s+/) : [];

    if (!userFilter && !this.selectedRole) return undefined;

    const roleFilter = this.selectedRole
      ? {
          claimGroupsInApplicationUsers: {
            any: { claimGroup: { name: { eq: this.selectedRole } } },
          },
        }
      : null;

    let nameFilter = null;

    if (words.length === 1) {
      const keyword = words[0];
      nameFilter = {
        or: [
          { firstName: { contains: keyword } },
          { lastName: { contains: keyword } },
          { email: { contains: keyword } },
        ],
      };
    } else if (words.length >= 2) {
      nameFilter = {
        and: [
          { firstName: { contains: words[0] } },
          { lastName: { contains: words[1] } },
        ],
      };
    }

    if (nameFilter && roleFilter) {
      return { and: [nameFilter, roleFilter] };
    }

    return nameFilter || roleFilter;
  }


  setPage(newPage: number): void {
    this.loadingUsers = true;
    this.page = newPage;
    this.odataHelper
      .getPaginated(this.applicationUserCrudClient, {
        filter: this.getFilterLogic(),
        top: this.countperpage,
        skip: this.page ? (this.page - 1) * this.countperpage : undefined,
        expand: {
          claimGroupsInApplicationUsers: {
            claimGroup: true,
          },
        },
        orderBy: ["firstName", "lastName"],
      })
      .then((response) => {
        const { value: users, count } = response;
        this.users = users;
        this.countTotal = count;

        this.loadingUsers = false;
      })
      .catch((response) => {
        this.error = true;
        this.loadingUsers = false;
      });
  }

  prevPage(): void {
    this.setPage(this.page - 1);
  }

  nextPage(): void {
    this.setPage(this.page + 1);
  }

  addNewUser(): void {
    this.hasLenderrole = false;
    this.isSelectedUserAdmin = false;
    this.userForm.$setPristine();
    this.currentItemRoleSet = [];
    this.selectedUser = {
      dealClientUniqueRef: undefined,
      fullName: undefined,
      hasActiveEnterpriseLicense: undefined,
      hasActiveSubscription: undefined,
      introducerCode: undefined,
      introducerId: undefined,
      inviteCode: undefined,
      isConnectUser: undefined,
      lenderProductTypesText: undefined,
      orgCode: undefined,
      orgUniqueRef: undefined,
      oidcId: undefined,
      name: undefined,
      subscriptionStatus: undefined,

      lenderProductTypes: undefined,

      agreedToTermsAndPP: false,
      applicantDefinedRole: undefined,
      applicantDefinedRoleIntroducer: undefined,
      applicantDefinedRoleOther: null,
      claimGroupsInApplicationUsers: [],
      createdDateTime: undefined,
      defaultBrokerOrganisationId: null,
      displayOrganisationAdminWelcomepage: false,
      email: null,
      emailOptOut: false,
      failedLoginAttempts: 0,
      firstName: null,
      id: 0,
      isDeleted: false,
      isEnabled: false,
      isLegacyUser: false,
      isLenderAdmin: false,
      isOrganisationAdmin: false,
      lastLoginDate: undefined,
      lastName: null,
      lastUpdatedDateTime: undefined,
      lenderId: null,
      lenderResultsTermsAgreed: false,
      level: 0,
      licenseMasterId: null,
      location: LocationEnum.London,
      miniBio: null,
      newUserEmailJourneyStarted: false,
      organisationId: null,
      organisationReferralId: null,
      phoneNumber: null,
      profileId: null,
      profilePictureUrl: null,
      referrer: undefined,
      referrerOther: null,
      representative: null,
      roleDescription: null,
      securityStamp: null,
      sendLenderInsightsEmail: false,
      temporaryAccount: false,
      userName: null,
      showAutofill: true,
      features: [],
    };
    this.lenderUserProductType = [];

    const clientClaimGroup = this.claimGroups.find((group) => group.name == "Client");
    this.selectedUser.claimGroupsInApplicationUsers = [
      {
        claimGroup: clientClaimGroup,
        claimGroupId: clientClaimGroup.id,
        id: 0,
        recordId: 0,
        isDeleted: false,
        lastUpdatedDateTime: undefined,
        createdDateTime: undefined,
      },
    ];
    this.getgroups();
  }

  async saveUser(): Promise<void> {
    this.dataLoading = true;
    try {
      let validUser = true;
      this.error = false;
      this.singleLenderAdminError = null;

      if (isNaN(this.selectedUser.introducerId)) {
        this.selectedUser.introducerId = null;
      }

      if (!this.selectedUser.userName) {
        this.selectedUser.userName = this.selectedUser.email; //set user name to be same as email address for now
      }

      if (this.hasLenderrole && !this.selectedUser.isLenderAdmin && this.selectedUser.lenderId != null) {
        let lenderAdmin = this.assignedLenderUsers.find((l) => l.isLenderAdmin && l.id != this.selectedUser.id);
        if (!lenderAdmin) {
          this.singleLenderAdminError = `Please assign a new Admin User.`;
          this.error = true;
          validUser = false;
        }
      }

      if (validUser) {
        let userPromise: ng.IPromise<ApplicationUser>;
        let claimsPromise: ng.IPromise<ClaimGroupsInApplicationUser[]>;
        const removedClaimGroupIds = this.selectedUser.claimGroupsInApplicationUsers
          .filter(
            (originalItem) =>
              !this.currentItemRoleSet.some((currentItem) => currentItem.name === originalItem.claimGroup.name),
          )
          .map((originalItem) => originalItem.claimGroupId || originalItem.claimGroup.id);
        const updateClaims = (userId: number): ng.IPromise<ClaimGroupsInApplicationUser[]> => {
          return this.claimClient.addRemoveUpdateClaimGroupsToAppUserOrUsers({
            claimGroupSets: [userId],
            claimGroupsToAddUpdate: this.currentItemRoleSet,
            claimGroupsToRemove: removedClaimGroupIds,
            removeExistingUnMentionedClaimGroups: false,
          });
        };

        const isNewUser: boolean = this.checkIsNewUser();

        if (isNewUser) {
          const newUser = await this.abstractedPostUser();
          userPromise = this.$q.resolve(newUser);
          claimsPromise = updateClaims(newUser.id);
        } else {
          userPromise = this.abstractedPatchUser();
          claimsPromise = updateClaims(this.selectedUser.id);
        }

        const [updatedUser, _] = await this.$q.all([userPromise, claimsPromise]);

        try {
          const response = await this.userClient.processUserRegistrationAndUpdate(updatedUser.id, isNewUser);

          if (response) {
            if (this.selectedUser.isLenderAdmin) {
              this.setPage(1);
            } else {
              this.setPage(this.page);
            }

            delete this.selectedUser;
            (this.$rootScope as any).formSaved = true;
          } else {
            this.error = true;
          }
        } catch (response) {
          this.error = true;
          if (response?.data?.ExceptionMessage === "No license to assign.") {
            this.selectedUser.isOrganisationAdmin = false;
            this.noLicenseToAssignForAdminMessage =
              "There isn't an available license to assign to this user therefore they have not been assigned as the admin for the organisation.";
          }
        }

        this.selectedUser.referrer = undefined;
      }
    } finally {
      this.dataLoading = false;
    }
  }

  checkIsNewUser(): boolean {
    return !this.selectedUser.id || this.selectedUser.id === 0;
  }

  abstractedPostUser() {
    const { claimGroupsInApplicationUsers, ...patchUser } = this.selectedUser;
    const postUser: ApplicationUserInsert = {
      ...patchUser,
      oidcId: patchUser.email,
      name: patchUser.userName,
    };

    return this.applicationUserCrudClient.post(postUser);
  }

  abstractedPatchUser() {
    const { claimGroupsInApplicationUsers, ...patchUser } = this.selectedUser;

    // Important for the time being that these are the same as the userName
    patchUser.oidcId = patchUser.userName;
    patchUser.name = patchUser.userName;

    return this.applicationUserCrudClient.patch(patchUser);
  }

  deleteUser(): void {
    this.applicationUserClient
      .markAsDeleted(this.selectedUser.id)
      .then((response) => {
        if (response) {
          this.users.splice(this.users.indexOf(this.selectedUser), 1);
          delete this.selectedUser;
        } else {
          this.error = true;
        }
      })
      .catch((response) => {
        this.error = true;
      });
  }

  extrasettings = {
    displayProp: "Name",
    smartButtonMaxItems: 3,
    smartButtonTextConverter: function (itemText: string, originalItem: any) {
      return originalItem.Name;
    },
    scrollable: true,
    selectedToTop: true,
    enableSearch: true,
  };

  checkIntroducerrole(data: ClaimGroup & { ticked: boolean }) {
    if (data.name == "Lender") {
      if (data.ticked == true) {
        this.hasLenderrole = true;
        this.isLender = true;
        this.selectedUser.sendLenderInsightsEmail = true;
        this.getAllLenders();
      } else {
        this.hasLenderrole = false;
        this.isLender = false;
        this.selectedUser.lenderId = null;
        this.selectedUser.isLenderAdmin = false;
        this.selectedUser.lenderProductTypes = 0;
        this.selectedUser.sendLenderInsightsEmail = false;
      }
    }

    if (data.name == "Broker") {
      this.isBroker = !this.isBroker;
    }

    if (data.name == "Admin") {
      this.isSelectedUserAdmin = !this.isSelectedUserAdmin;
    }
  }

  getActivePackagePricingsForTrialLicense() {
    this.allActiveAppPackagePrices = [];
    this.$paymentClient
      .getActivePackagePricingsForTrialLicense(this.selectedUser.userName)
      .then((response) => {
        this.allActiveAppPackagePrices = response;
      })
      .finally(() => {
        this.assignLicense = !this.assignLicense;
      });
  }

  getLicenseStatusText() {
    this.allActiveAppPackagePrices = [];
    this.userClient.getLicenseStatusText(this.selectedUser.userName).then((response) => {
      this.licenseStatusText = response;
    });
  }

  onSelectingUser(user: Expand<ApplicationUser, { claimGroupsInApplicationUsers: { claimGroup: true } }>) {
    this.hasLenderrole = false;
    this.selectedUser = user;
    this.singleLenderAdminError = "";
    this.noLicenseToAssignForAdminMessage = "";
    this.hasLenderrole =
      this.selectedUser.claimGroupsInApplicationUsers.find((role) => role.claimGroup.name === "Lender") !== undefined;
    if (this.hasLenderrole) {
      this.getAllLenders();
      this.initLenderUserProductType();
      if (this.selectedUser.lenderId) {
        this.fetchAllLenderUsers(this.selectedUser.lenderId);
      }
    }
    this.getgroups();
    this.isUserBroker();
    this.isUserAdmin();
    this.isUserLender();
    this.isUserOrgAdmin();
    this.getLicenseStatusText();
  }

  onChangingPackage(selectedPackage) {
    if (this.selectedProductList != null && this.selectedProductList.length > 0) {
      var found = this.selectedProductList.find(function (product) {
        return product.id == selectedPackage.Id;
      });

      if (found) {
        this.selectedProductList = this.selectedProductList.filter(function (e) {
          return e.id != selectedPackage.Id;
        });
      } else {
        this.selectedProductList.push(selectedPackage);
      }
    } else {
      this.selectedProductList.push(selectedPackage);
    }
  }

  assignLicenseToUser() {
    this.userClient
      .assignTrialLicenseToUser(this.licenseEndDate, this.selectedUser.id, this.selectedProductList)
      .then((response) => {
        if (response) {
          this.message = `Trial license has been assigned to ${this.selectedUser.fullName}`;
          this.introduceClientModal = 2;
          this.allActiveAppPackagePrices = [];
        } else {
          this.message = `Problem while assigning trial license, please try after some time.`;
          this.introduceClientModal = 2;
        }
      });
  }

  goToSettingPage() {
    this.$location.path(`/settings/${this.selectedUser.id}`);
  }

  sendTestEmail(): void {
    this.userClient
      .sendTestEmail(this.selectedUser.email, this.testEmailSub, this.testEmailBody)
      .then((response: boolean) => {
        if (response) {
          this.message = `Test email has been sent to ${this.selectedUser.fullName}`;
          this.showTestEmailModal = false;
          this.introduceClientModal = 2;
        } else {
          this.error = true;
        }
      })
      .catch((response) => {
        this.error = true;
      });
  }

  initLenderUserProductType() {
    if (!this.selectedUser.lenderProductTypes) {
      this.selectedUser.lenderProductTypes = 0;
    } else {
      for (let i = 1; i >= 0; i *= 2) {
        if (this.selectedUser.lenderProductTypes >= i) {
          //number is in enum sum, add it to object
          if (this.selectedUser.lenderProductTypes & i) {
            this.lenderUserProductType[i] = true;
          } else {
            this.lenderUserProductType[i] = false;
          }
        } else {
          return;
        }
      }
    }
  }

  updateLenderUserProductTypes(item: LenderProductTypeEnum) {
    this.selectedUser.lenderProductTypes =
      this.selectedUser.lenderProductTypes > 0 ? this.selectedUser.lenderProductTypes : 0;
    if (item == LenderProductTypeEnum.All) {
      if (this.lenderUserProductType[item] == false) {
        this.selectedUser.lenderProductTypes -= item;
      } else {
        this.lenderUserProductType.forEach((value, index) => {
          this.lenderUserProductType[index] = false;
        });

        this.selectedUser.lenderProductTypes = 0;

        this.lenderUserProductType[item] = true;
        this.selectedUser.lenderProductTypes += item;
      }
    } else {
      //if we are setting item to false and item exists, remove it, else add it
      if (this.lenderUserProductType[item] === true) {
        this.selectedUser.lenderProductTypes += item;
      } else if (this.selectedUser.lenderProductTypes > 0) {
        this.selectedUser.lenderProductTypes -= item;
      }
    }
  }

  getAllLenders() {
    this.lenderClient.fetchAll().then((response) => {
      this.lenders = response;
    });
  }

  isLenderUserProductTypeEmpty() {
    if (this.lenderUserProductType.length === 0) return true;

    for (let i = 0; i < this.lenderUserProductType.length; i++) {
      let value = this.lenderUserProductType[i];
      if (value !== undefined && value !== null && value !== false) {
        return false;
      }
    }
    return true;
  }

  fetchAllLenderUsers(lenderId) {
    this.userClient.getUsersByLenderId(lenderId).then((response) => {
      this.assignedLenderUsers = response;
    });
  }

  onIsLenderAdminChange() {
    if (!this.selectedUser.isLenderAdmin && this.hasLenderrole && this.selectedUser.id) {
      let selectedUserFrom = this.assignedLenderUsers.find((l) => l.id == this.selectedUser.id);
      let lenderAdmin = this.assignedLenderUsers.find((l) => l.isLenderAdmin && l.id != this.selectedUser.id);
      if (selectedUserFrom?.isLenderAdmin && !lenderAdmin) {
        this.singleLenderAdminError = `Please assign a new Admin User.`;
      }
    } else if (this.selectedUser.isLenderAdmin) {
      this.singleLenderAdminError = "";
    }
  }

  onExpandingAssignTrialLicense() {
    if (this.assignLicense) {
      this.getActivePackagePricingsForTrialLicense();
    } else {
      this.assignLicense = !this.assignLicense;
    }
  }

  isOrganisationAdminChecked(): boolean {
    return this.currentItemRoleSet.some((role) => role.name === "OrganisationAdmin");
  }

  toggleOrganisationAdminRole(): void {
    const orgAdminRole = this.claimGroups.find((role) => role.name === "OrganisationAdmin");

    const alreadySelected = this.currentItemRoleSet.some((role) => role.name === "OrganisationAdmin");

    if (alreadySelected) {
      this.currentItemRoleSet = this.currentItemRoleSet.filter((role) => role.name !== "OrganisationAdmin");
      (orgAdminRole as any).ticked = false;
      this.selectedUser.isOrganisationAdmin = false;
    } else {
      this.currentItemRoleSet = [...this.currentItemRoleSet, orgAdminRole];
      (orgAdminRole as any).ticked = true;
    }
  }

  onPrimaryAdminChange(): void {
    const orgAdminRole = this.claimGroups.find((role) => role.name === "OrganisationAdmin");

    const alreadySelected = this.currentItemRoleSet.some((role) => role.name === "OrganisationAdmin");

    if (this.selectedUser.isOrganisationAdmin) {
      if (!alreadySelected) {
        this.currentItemRoleSet = [...this.currentItemRoleSet, orgAdminRole];
        (orgAdminRole as any).ticked = true;
      }
    }
  }

  isOrganisationReferralRequired() {
    return (
      !this.isBroker && !this.isLender && this.selectedUser != null && this.selectedUser.defaultBrokerOrganisationId > 0
    );
  }
}
